module.exports = __webpack_public_path__ + "static/media/down-arrow.e6946033.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Dropdown/down-arrow.svg
// module id = 290
// module chunks = 0